import LocalizedStrings from 'localized-strings';

interface InternationalTransferRecipientLocale {
  failedToSelectRecipient: string;
  newRecipient: string;
  recipient: string;
}

export default new LocalizedStrings<InternationalTransferRecipientLocale>({
  en: {
    failedToSelectRecipient: 'An error occurred',
    newRecipient: 'Add new beneficiary',
    recipient: 'Beneficiary',
  },
  fr: {
    failedToSelectRecipient: 'Une erreur est survenue',
    newRecipient: 'Ajouter un bénéficiaire',
    recipient: 'Bénéficiaire',
  },
} as const);
